<template>
  <div id="not-found">
    <div class="not-found-container">
      <h2>{{ message }}</h2>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  props: {
    message: {
      type: String,
      required: false,
      default: 'Nothing found!'
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 80px);
  h2 {
    @include font-33;
    color: $c_black;
  }
}
</style>
